import React, { Component, Suspense } from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import Loadable from "react-loadable";
import * as signalR from "@aspnet/signalr";
import axios from "axios";

import "../../node_modules/font-awesome/scss/font-awesome.scss";
import { adalConfig } from "../adalConfig";
import Loader from "./layout/Loader";
import Aux from "../hoc/_Aux";
import ScrollToTop from "./layout/ScrollToTop";
import routes from "../route";
import config from "../config.js";
import { connect } from "react-redux";
import { EVENT_NOTIFICATION } from "./../store/actions";
import { withRouter } from "react-router-dom";
import AADService from "../AADService";
import { authGetTokenForResource } from "../tokenConfig";
import { NOTIFICATION_FUNCTION_CONNECTION_URL } from "../App/serverConfig";
import ReactGa from "react-ga";

const AdminLayout = Loadable({
	loader: () => import("./layout/AdminLayout"),
	loading: Loader,
});

class App extends Component {
	componentDidMount() {
		//
		let tracking_ID =
			process.env.NODE_ENV === "production" &&
			process.env.REACT_APP_RUN_ENV === "production"
				? "UA-199509014-2"
				: "UA-199509014-1";
		ReactGa.initialize(tracking_ID);
		//to report pageview
		ReactGa.pageview(window.location.pathname + window.location.search);
		this.AzureADService = new AADService();
		const user = this.AzureADService.getUser();
		authGetTokenForResource(adalConfig.clientId)
			.then((token) => {
				const config = {
					headers: {
						Authorization: "Bearer " + token,
					},
				};
				axios
					.post(NOTIFICATION_FUNCTION_CONNECTION_URL, null, config)
					.then((response) => {
						let hubConnection = new signalR.HubConnectionBuilder()
							.withUrl(response.data.url, {
								accessTokenFactory: () => response.data.accessToken,
							})
							//.configureLogging(signalR.LogLevel.Trace)
							.build();
						hubConnection
							.start()
							.then(() => console.log("Connection started!"))
							.catch((err) =>
								console.log("Error while establishing connection :(")
							);
						// eslint-disable-next-line no-useless-escape
						hubConnection.on('"' + user.userName + '"', (receivedMessage) => {
							this.props.eventNotification(receivedMessage);
						});
					})
					.catch((error) => {
						console.log(error);
					});
			})
			.catch((error) => console.log(error));
	}

	render() {
		const menu = routes.map((route, index) => {
			return route.component ? (
				<Route
					key={index}
					path={route.path}
					exact={route.exact}
					name={route.name}
					render={(props) => <route.component {...props} />}
				/>
			) : null;
		});

		return (
			<Aux>
				<ScrollToTop>
					<Suspense fallback={<Loader />}>
						<Switch>
							{menu}
							<Route path='/ie' component={AdminLayout} />
							<Redirect exact from='/' to={config.defaultPath} />
						</Switch>
					</Suspense>
				</ScrollToTop>
			</Aux>
		);
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		eventNotification: (receivedMessage) =>
			dispatch({
				type: EVENT_NOTIFICATION,
				payload: receivedMessage,
			}),
	};
};

export default withRouter(connect(null, mapDispatchToProps)(App));
